import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import Map from "./MapBase";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MapBigCardContainer, MapBigBoxContainer, MapBigMapBoxContainer, CardBigMapContainer } from "../assets/style";
import SearchInput from "./SearchInput";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";

export interface BigMapCardProps {
    selectPosition: any,
    isInput: boolean,
    date?: any,
    setDate?: any,
    startTime?: any,
    setStartTime?: any,
    endTime?: any,
    setEndTime?: any,
    project?: any
    schedule?: any
}


const MapBigCard: React.FC<BigMapCardProps> = ({ selectPosition, isInput, date, setDate, startTime, setStartTime, endTime, setEndTime, project, schedule }) => {
    // const [coordinates, setCoordinates] = useState(`${selectPosition?.lat}, ${selectPosition?.lng}`);
    const { t, i18n } = useTranslation();
    // useEffect(() => {
    // console.log("selectPosition in map,", selectPosition)
    //     console.log("project in map,", project)
    //     console.log("schedule", schedule)
    //     if (selectPosition?.lat == null || selectPosition?.lng == null) {
    //         setCoordinates("22.3780027, 114.1830961");
    //     }
    // }, [])
    // console.log("date", date)
    //console.log("startTime", startTime)
    //console.log("endTime", endTime)
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/project-detail', { state: project });
    };
    return (
        <>
            <Box>
                <MapBigCardContainer>
                    <MapBigBoxContainer>
                        <Grid container spacing={0} sx={{ height: "80%" }}>
                            <Grid item xs={4}>
                                <Typography style={{ fontSize: 16 }} >
                                    {t("Project No.:")}
                                </Typography>
                            </Grid>
                            <Grid item xs={7}>
                                {/* <Typography style={{ fontSize: 16 }} >
                                    {project?.number || schedule?.projectNumber || selectPosition?.projectNumber}
                                </Typography> */}
                                <Typography
                                    style={{ fontSize: 16 }}>
                                    <a href="#" onClick={handleClick}>
                                        {project?.number || schedule?.projectNumber || selectPosition?.projectNumber}
                                    </a>
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography style={{ fontSize: 16 }} >
                                    {t("Project Name:")}
                                </Typography>
                            </Grid>
                            <Grid item xs={7}>
                                <Typography style={{ fontSize: 16 }} >
                                    {project?.name || schedule?.projectName || selectPosition?.projectName}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography style={{ fontSize: 16 }} >
                                    {t("Loaction No.:")}
                                </Typography>
                            </Grid>
                            <Grid item xs={7}>
                                <Typography style={{ fontSize: 16 }} >
                                    {selectPosition?.code}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography style={{ fontSize: 16 }} >
                                    {t("Location: ")}
                                </Typography>
                            </Grid>
                            <Grid item xs={7}>
                                <Typography style={{ fontSize: 16 }} >
                                    {selectPosition?.name}
                                </Typography>
                            </Grid>

                            <Grid item xs={4}>
                                <Typography style={{ fontSize: 16 }} >
                                    {t("Date: ")}
                                </Typography>
                            </Grid>
                            {isInput ? (
                                <Grid item xs={8}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                                        <DatePicker
                                            sx={{
                                                '& .MuiInputBase-root': { height: '24px', width: '80%' }
                                            }}
                                            format="DD/MM/YYYY"
                                            value={date}
                                            onChange={(date) => {
                                                setDate(date);
                                            }} />
                                    </LocalizationProvider>
                                </Grid>
                            ) : (
                                <Grid item xs={7}>
                                    <Typography style={{ fontSize: 16 }} >
                                        {schedule?.workDate || selectPosition.date.toString()}
                                    </Typography>
                                </Grid>
                            )}

                            <Grid item xs={4}>
                                <Typography style={{ fontSize: 16 }} >
                                    {t("Start Time:")}
                                </Typography>
                            </Grid>
                            {isInput ? (
                                <Grid item xs={7}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            sx={{ '& .MuiInputBase-root': { height: '24px', width: '91.5%' } }}
                                            value={startTime}
                                            onChange={(newValue) => setStartTime(newValue)}
                                            ampm={false}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            ) : (
                                <Grid item xs={7}>
                                    <Typography style={{ fontSize: 16 }} >
                                        {schedule?.startTime || schedule?.scheduleStartTime || startTime}
                                    </Typography>
                                </Grid>
                            )}

                            <Grid item xs={4}>
                                <Typography style={{ fontSize: 16 }} >
                                    {t("End Time:")}
                                </Typography>
                            </Grid>

                            {isInput ? (
                                <Grid item xs={7}>
                                    <Typography style={{ fontSize: 16 }} >
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <TimePicker
                                                sx={{ '& .MuiInputBase-root': { height: '24px', width: '91.5%' } }}
                                                value={endTime}
                                                onChange={(newValue) => setEndTime(newValue)}
                                                ampm={false}
                                            />
                                        </LocalizationProvider>
                                    </Typography>
                                </Grid>
                            ) : (
                                <Grid item xs={7}>
                                    <Typography style={{ fontSize: 16 }} >
                                        {schedule?.endTime || schedule?.scheduleEndTime || endTime}
                                    </Typography>
                                </Grid>
                            )}

                        </Grid>
                    </MapBigBoxContainer>
                    <MapBigMapBoxContainer>
                        <CardBigMapContainer>
                            <Map zoom={19} coordinates={`${selectPosition?.lat}, ${selectPosition?.lng}` || "22.3780027, 114.1830961"} name={selectPosition?.name} isInput={false} />
                        </CardBigMapContainer>
                        <br />
                        <Typography variant="body2" color="text.secondary" fontSize={16} lineHeight={2}>
                            {/* {t("Location of Confided Space: ")}{selectPosition?.detail || selectPosition?.name} */}
                            {/* <br /> */}
                            {t("Coordinates: ")}{`${selectPosition?.lat}, ${selectPosition?.lng}` || "22.3780027, 114.1830961"}
                        </Typography>
                    </MapBigMapBoxContainer>
                </MapBigCardContainer >
            </Box >
        </>
    );
}

export default MapBigCard;